module.exports = __webpack_public_path__ + "assets/img/MI-RMI422-AW-020-1.ea562ded.jpg";